import { toArray } from "./toArray.js";
export const firstOrDefaultAsync = async (source, predicate) => {
    const data = await toArray(source);
    for (const value of data) {
        if (await predicate(value) === true) {
            return value;
        }
    }
    return null;
};
